import React from 'react';
import {withNamespaces} from "react-i18next";
import ThemeSelectContainer from "../containers/SearchForm/ThemeSelectContainer";
import HikeSelectContainer from "../containers/SearchForm/HikeSelectContainer";
import DateRangePickerContainer from "../../../shared/ui/containers/DateRangePickerContainer";

const SearchForm = ({  t, theme, hike, isLoading, onThemeChanged, onHikeChanged, onConfirmedChanged, onDateRangeChanged, from, to }) =>
    <div className="search-form container">
        {isLoading && <div className="fa-2x loading-spinner"><i className="fal fa-spinner-third fa-spin"></i></div>}
        <form>
            <div className="filters-bar">
                <div className="left">
                    <div className="form-group">
                        <label htmlFor="theme">Région / Thème</label>
                        <ThemeSelectContainer onThemeChanged={onThemeChanged} theme={theme} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="route">Itinéraire</label>
                        <HikeSelectContainer onHikeChanged={onHikeChanged} theme={theme} hike={hike} />
                    </div>
                </div>
                <div className="right">
                    <div className="form-group input-period">
                        <label>Période</label>
                        <DateRangePickerContainer onSubmit={onDateRangeChanged} from={from} to={to}/>
                    </div>
                </div>
            </div>
            <div className="options">
                <div className="checkbox">
                    <label>
                        <input type="checkbox" onChange={onConfirmedChanged} />
                        N'afficher que les départs confirmés
                    </label>
                </div>
            </div>
        </form>
    </div>
;

export default withNamespaces()(SearchForm);
